export const HOME = {
  emergentLink: "emergent-link",
};

export const HUB = {
  header: "app-header",
  logo: "kw-logo",
  reportDriveLink: "self-report-drive-link",
  searchInput: "search-listings-input",
  postOpportunityBtn: "post-opportunity-btn",
  importCsvBtn: "import-csv-btn",
  tabsAvailable: "tab-available",
  tabsClaimed: "tab-claimed",
  listingsGrid: "listings-grid",
  emptyState: "empty-state",
};

export const CARD = {
  root: (id) => `listing-card-${id}`,
  claimBtn: (id) => `claim-btn-${id}`,
  duplicateBtn: (id) => `duplicate-btn-${id}`,
  claimedBadge: (id) => `claimed-badge-${id}`,
};

export const POST_MODAL = {
  root: "post-modal",
  fieldAddress: "post-field-address",
  fieldCity: "post-field-city",
  fieldCounty: "post-field-county",
  fieldPrice: "post-field-price",
  fieldDom: "post-field-dom",
  fieldDate: "post-field-date",
  fieldAddDate: "post-field-add-date",
  dateChip: (i) => `post-date-chip-${i}`,
  removeDate: (i) => `post-remove-date-${i}`,
  fieldTime: "post-field-time",
  fieldNotes: "post-field-notes",
  fieldAgentName: "post-field-agent-name",
  fieldAgentPhone: "post-field-agent-phone",
  fieldAgentEmail: "post-field-agent-email",
  checkNoReferral: "post-check-no-referral",
  checkMarketing: "post-check-marketing",
  checkNotifyReport: "post-check-notify-report",
  submitBtn: "post-submit-btn",
  closeBtn: "post-close-btn",
};

export const CSV_MODAL = {
  root: "csv-modal",
  openBtn: "csv-open-btn",
  closeBtn: "csv-close-btn",
  fileInput: "csv-file-input",
  downloadTemplateBtn: "csv-download-template-btn",
  submitBtn: "csv-submit-btn",
  previewRow: (i) => `csv-preview-row-${i}`,
  errorList: "csv-error-list",
};

export const CLAIM_MODAL = {
  root: "claim-modal",
  fieldFirstName: "claim-field-first-name",
  fieldLastName: "claim-field-last-name",
  fieldPhone: "claim-field-phone",
  fieldEmail: "claim-field-email",
  fieldOffice: "claim-field-office",
  checkSigns: "claim-check-signs",
  checkCertified: "claim-check-certified",
  checkClaimEarly: "claim-check-claim-early",
  checkContactAgent: "claim-check-contact-agent",
  checkKWWellingtonAgent: "claim-check-kw-wellington",
  checkSelfReport: "claim-check-self-report",
  submitBtn: "claim-submit-btn",
  closeBtn: "claim-close-btn",
};

export const REPORT_MODAL = {
  root: "report-modal",
  openBtn: "report-open-btn",
  closeBtn: "report-close-btn",
  fieldName: "report-field-name",
  fieldEmail: "report-field-email",
  fieldPhone: "report-field-phone",
  fieldAddress: "report-field-address",
  fieldListingAgent: "report-field-listing-agent",
  fileSignIn: "report-file-signin",
  fileSocial: "report-file-social",
  contactYes: "report-contact-yes",
  contactNo: "report-contact-no",
  enrolledYes: "report-enrolled-yes",
  enrolledNo: "report-enrolled-no",
  submitBtn: "report-submit-btn",
};
